export default "__VITE_ASSET__dc35cb9b__"